import { assetReducer } from "./assetReducer";
import { combineReducers } from "redux";
import {
  CheckInReducer,
  CheckOutReducer,
  EmployeeCurrentMonthAttendanceReducer,
  UserAttendanceReducer,
  getLastAttendanceReducer,
  updateAttendanceReducer,
} from "./Attendance";
import {
  AuthReducer,
  ChangePassReducer,
  ChangePinReducer,
  ForgotPasswordReducer,
  ResetPasswordReducer,
  currentUserReducer,
} from "./Auth";
import {
  CreateDepartmentReducer,
  DeleteDepartmentReducer,
  DepartmentsDetailsReducer,
  UpdateDepartmentReducer,
} from "./Departments";
import {
  CreateDesignationReducer,
  DeleteDesignationReducer,
  DesignationDetailsReducer,
  UpdateDesignationReducer,
} from "./Designations";
import {
  CreateHolidayReducer,
  DeleteHolidayReducer,
  HolidayDetailsReducer,
  UpdateHolidayReducer,
} from "./Holidays";
import {
  AllDepartmentsReducer,
  AllDesignationsReducer,
  AllEmployeesReducer,
  getEmployeeDropdownReducer,
  AllFilteredEmployeesReducer,
  AllHolidaysReducer,
  AllLeavesReducer,
  AllShiftsReducer,
  getEmployeeReducer,
  HRDashboard,
  registerReducer,
} from "./HR";
import {
  CreateLeaveReducer,
  DeleteLeaveReducer,
  LeaveDetailsReducer,
  UpdateLeaveReducer,
} from "./Leaves";
import {
  CreateShiftReducer,
  DeleteShiftReducer,
  ShiftDetailsReducer,
  UpdateShiftReducer,
} from "./Shifts";
import {
  EmployeeDashboard,
  updateEmployeeReducer,
  deleteEmployeeReducer,
  updateProfilePictureReducer,
  manageLeavesReducer,
  EmployeePayrollsReducer,
  employeeNotificationsReducer,
  markNotificationAsRead,
  banEmployeeReducer,
  unBanEmployeeReducer,
  activeEmployeeReducer,
  inActiveEmployeeReducer,
} from "./Employee";
import { monthlyAttendanceReducer, todaysAttendanceReducer } from "./TimeSheet";
import {
  DeleteAnnouncementReducer,
  announcementReducer,
  getAllAnnouncementReducer,
} from "./Announcement";
import {
  AllLeaveApplicationsReducer,
  CreateLeavesReducer,
  IndivisualLeaveDetailsReducer,
  UpdateLeaveApplicationReducer,
  UpdateLeaveApplicationContentReducer,
  LeavesDeleteReducer,
  CurrentUserLeaveApplicationsReducer,
  LineManagerLeaveApplicationsReducer,
  SendLeaveApplicationCommentReducer,
} from "./LeaveApplications";
import {
  AllTicketsReducer,
  CreateTicketReducer,
  IndivisualTicketDetailsReducer,
  UpdateTicketReducer,
  UpdateTicketContentReducer,
  TicketsDeleteReducer,
  CurrentUserTicketsReducer,
  assignedTicketsReducer,
  SendTicketCommentReducer,
} from "./Tickets";
import {
  CreatePayrollByDateReducer,
  CreatePayrollByDepartmentReducer,
  CreatePayrollReducer,
  deleteEmployeePayrollsReducer,
  lastPayrollsReducer,
  PayrollsByIdReducer,
  PayrollsReducer,
  updateEmployeePayrollsReducer,
} from "./payrolls";
import { createTaxConfigReducer, taxConfigsReducer, updateTaxConfigReducer } from "./taxes";
import {
  AllRequestsReducer,
  CreateRequestReducer,
  CurrentUserRequestsReducer,
  IndivisualRequestDetailsReducer,
  RequestDeleteReducer,
} from "./Requests";
import {
  AllLoanRequestsReducer,
  CreateLoanRequestReducer,
  CurrentUserLoanRequestsReducer,
  IndivisualLoanRequestDetailsReducer,
  LoanRequestDeleteReducer,
} from "./LoanRequests";
import {
  AllPurchaseRequisitionsReducer,
  CreatePurchaseRequisitionReducer,
  CurrentUserPurchaseRequisitionsReducer,
  PurchaseRequisitionDetailsReducer,
  PurchaseRequisitionDeleteReducer,
  UpdatePurchaseRequisitionStatusReducer,
  SendPurchaseRequisitionCommentReducer,
} from "./PurchaseRequisitions";
import {
  AllPettyPurchasesReducer,
  CreatePettyPurchaseReducer,
  CurrentUserPettyPurchasesReducer,
  PettyPurchaseDetailsReducer,
  PettyPurchaseDeleteReducer,
  UpdatePettyPurchaseStatusReducer,
  SendPettyPurchaseCommentReducer,
} from "./PettyPurchases";
import { chatReducer } from "./chatReducer";

const rootReducer = combineReducers({
  asset: assetReducer,
  //*********************** Auth ****************************
  Auth: AuthReducer,
  passChanged: ChangePassReducer,
  pinChanged: ChangePinReducer,
  forgotPassword: ForgotPasswordReducer,
  resetPassword: ResetPasswordReducer,
  //HR
  //********************dashboard****************************
  dashboardData: HRDashboard,
  departments: AllDepartmentsReducer,
  designations: AllDesignationsReducer,
  leaves: AllLeavesReducer,
  shifts: AllShiftsReducer,
  holidays: AllHolidaysReducer,
  employees: AllEmployeesReducer,
  employeeDropdown: getEmployeeDropdownReducer,
  //register employee
  register: registerReducer,
  employeeUpdate: updateEmployeeReducer,
  employeeDelete: deleteEmployeeReducer,
  updateProfilePic: updateProfilePictureReducer,

  // Create Announcement

  createAnnouncement: announcementReducer,
  getAnnouncement: getAllAnnouncementReducer,
  deleteAnnouncement: DeleteAnnouncementReducer,

  //************************hr setup***********************

  //department
  createDepartment: CreateDepartmentReducer,
  departmentDetails: DepartmentsDetailsReducer,
  updateDepartment: UpdateDepartmentReducer,
  deleteDepartment: DeleteDepartmentReducer,
  //designation
  createDesignation: CreateDesignationReducer,
  designationDetails: DesignationDetailsReducer,
  updateDesignation: UpdateDesignationReducer,
  deleteDesignation: DeleteDesignationReducer,
  //shift
  createShift: CreateShiftReducer,
  shiftDetails: ShiftDetailsReducer,
  updateShift: UpdateShiftReducer,
  deleteShift: DeleteShiftReducer,
  //holiday
  createHoliday: CreateHolidayReducer,
  holidayDetails: HolidayDetailsReducer,
  updateHoliday: UpdateHolidayReducer,
  deleteHoliday: DeleteHolidayReducer,
  //leave

  createLeave: CreateLeaveReducer,
  leaveDetails: LeaveDetailsReducer,
  updateLeave: UpdateLeaveReducer,
  deleteLeave: DeleteLeaveReducer,

  // Leave Application
  createLeaveApplication: CreateLeavesReducer,
  leaveApplicationDetails: IndivisualLeaveDetailsReducer,
  UpdateLeaveApplication: UpdateLeaveApplicationReducer,
  updateLeaveApplication: UpdateLeaveApplicationContentReducer,
  LeavesApplicationDelete: LeavesDeleteReducer,
  currentUserLeaveApplications: CurrentUserLeaveApplicationsReducer,
  leaveApplications: AllLeaveApplicationsReducer,
  lineManagerLeaveApplications: LineManagerLeaveApplicationsReducer,
  leaveComment: SendLeaveApplicationCommentReducer,

  // Tickets
  AllTicket: AllTicketsReducer,
  CreateTicket: CreateTicketReducer,
  ticketDetail: IndivisualTicketDetailsReducer,
  ticketUpdated: UpdateTicketReducer,
  updateTicketContent: UpdateTicketContentReducer,
  ticketDeleted: TicketsDeleteReducer,
  currentUserTickets: CurrentUserTicketsReducer,
  assignedTickets: assignedTicketsReducer,
  ticketComment: SendTicketCommentReducer,

  //************************employee***********************
  employee: getEmployeeReducer,
  employeeNotifications: employeeNotificationsReducer,
  markAsRead: markNotificationAsRead,
  filteredEmployees: AllFilteredEmployeesReducer,

  //***********************Attendance************************
  currentMonthAttendance: EmployeeCurrentMonthAttendanceReducer,
  lastAttendance: getLastAttendanceReducer,
  checkIn: CheckInReducer,
  checkOut: CheckOutReducer,
  userAttendance: UserAttendanceReducer,
  updateAttendance: updateAttendanceReducer,

  //***********************TimeSheet************************
  monthlyTimesheet: monthlyAttendanceReducer,
  todaysTimesheet: todaysAttendanceReducer,

  //***********************Employee************************
  EmployeeDashboardData: EmployeeDashboard,
  currentUser: currentUserReducer,
  manageLeaves: manageLeavesReducer,
  EmployeePayrolls: EmployeePayrollsReducer,
  banEmployee: banEmployeeReducer,
  unBanEmployee: unBanEmployeeReducer,
  activeEmployee: activeEmployeeReducer,
  inActiveEmployee: inActiveEmployeeReducer,

  //***********************payrolls************************
  lastPayrolls: lastPayrollsReducer,
  payrollById: PayrollsByIdReducer,
  payrolls: PayrollsReducer,
  createPayroll: CreatePayrollReducer,
  createPayrollByDepartment: CreatePayrollByDepartmentReducer,
  createPayrollByDate: CreatePayrollByDateReducer,
  updatePayroll: updateEmployeePayrollsReducer,
  deletePayroll: deleteEmployeePayrollsReducer,

  //***********************taxes************************
  taxConfigs: taxConfigsReducer,
  createTaxConfig: createTaxConfigReducer,
  updateTaxConfig: updateTaxConfigReducer,

  //***********************requests************************
  createRequest: CreateRequestReducer,
  getRequests: AllRequestsReducer,
  currentUserRequest: CurrentUserRequestsReducer,
  requestDetails: IndivisualRequestDetailsReducer,
  deleteRequest: RequestDeleteReducer,
  //***********************loan requests************************
  createLoanRequest: CreateLoanRequestReducer,
  getLoanRequests: AllLoanRequestsReducer,
  currentUserLoanRequest: CurrentUserLoanRequestsReducer,
  loanRequestDetails: IndivisualLoanRequestDetailsReducer,
  deleteLoanRequest: LoanRequestDeleteReducer,
  //************************purchase requisitions************************
  createPurchaseRequisition: CreatePurchaseRequisitionReducer,
  getPurchaseRequisitions: AllPurchaseRequisitionsReducer,
  currentUserPurchaseRequisition: CurrentUserPurchaseRequisitionsReducer,
  purchaseRequisitionDetails: PurchaseRequisitionDetailsReducer,
  deletePurchaseRequisition: PurchaseRequisitionDeleteReducer,
  updatePurchaseRequisitionStatus: UpdatePurchaseRequisitionStatusReducer,
  sendPurchaseRequisitionComment: SendPurchaseRequisitionCommentReducer,
  //************************petty purchases************************
  createPettyPurchase: CreatePettyPurchaseReducer,
  getPettyPurchases: AllPettyPurchasesReducer,
  currentUserPettyPurchase: CurrentUserPettyPurchasesReducer,
  pettyPurchaseDetails: PettyPurchaseDetailsReducer,
  deletePettyPurchase: PettyPurchaseDeleteReducer,
  updatePettyPurchaseStatus: UpdatePettyPurchaseStatusReducer,
  sendPettyPurchaseComment: SendPettyPurchaseCommentReducer,
  //***********************AI Chat************************
  chat: chatReducer,
});

export default rootReducer;
